import { MutationTree } from 'vuex';
import { UserCalendar } from '@/services/undergrad/pegasus-epona/user-calendar.service';
import { CalendarState } from './state';

const mutations: MutationTree<CalendarState> = {
  SET_USER_CALENDAR(state, userCalendar?: UserCalendar) {
    state.userCalendar = userCalendar;
  },
  SET_IS_CONNECTING_CALENDAR(state, isConnectingCalendar: boolean) {
    state.isConnectingCalendar = isConnectingCalendar;
  },
};

export default mutations;
